var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import SearchableJsonView from "../../../../../../lib/comps/DevTool/util/SearchableJsonView";
import devToolMixin from '../../../util/devToolMixin';
import CodeEditor from './CodeEditor';
import { set } from "lodash-es";
let PropEditor = class PropEditor extends Mixins(devToolMixin) {
  constructor() {
    super(...arguments);
    this.editId = false;
    this.propSearchInput = '';
    this.maxHeight = 'calc(100%-43px)';
  }
  get compPath() {
    return this.bus.activeCompInfo.compPath;
  }
  // 这里做一次筛选，如果用户开启了default props，没有被变动过的值不写入layout
  // 这里没办法用designer的updateCompProp 因为可能写入events等信息...
  handleDisplayDataChange(newVal) {
    // this.activeLayout = newVal;
    const temp = {
      ...this.activeLayout,
      ...newVal
    };
    if (this.bus.options.showDefaultProps) {
      temp.props = Object.entries(temp.props || {}).filter(([key, val]) => val !== this.defaultProps[key]).reduce((o, [k, v]) => set(o, k, v), {});
    }
    this.activeLayout = temp;
  }
  get editContainer() {
    const {
      children,
      slots,
      scopedSlots,
      type,
      componentId,
      ...display
    } = this.activeLayout;
    // normalize displayData
    let displayData = JSON.parse(JSON.stringify(display));
    if (this.bus.options.showDefaultProps) {
      displayData = {
        ...displayData,
        props: {
          ...this.defaultProps,
          ...displayData.props
        },
        events: displayData.events || {} // default events
      };
    } else {
      displayData.props = Object.entries(displayData.props || {}).filter(([key, val]) => val !== this.defaultProps[key]).reduce((o, [k, v]) => set(o, k, v), {});
      if (!Object.keys(displayData.events || {}).length) delete displayData.events;
    }
    if (!Object.keys(displayData).length) {
      displayData = {
        props: {},
        events: {}
      };
    }
    return [this.headerLine({
      children,
      slots,
      scopedSlots,
      type,
      componentId
    }), this.editField(displayData)];
  }
  handleIdChange(e) {
    this.bus.$set(this.bus.activeCompInfo.layout, 'componentId', e.target.value);
    this.$set(this, 'editId', false);
  }
  editField(displayData) {
    const h = this.$createElement;
    // 编辑面板 Tree, YAML, JSON 三种格式
    switch (this.editOption) {
      case 'tree':
        return Object.keys(displayData).map(key => h(SearchableJsonView, {
          "class": "ucd-devTool-layout-propPanel-json",
          "attrs": {
            "value": displayData[key],
            "initKey": key,
            "defaultValue": this.defaultProps,
            "rootLevelKeys": Object.keys(displayData),
            "searchPlaceholder": "过滤",
            "searchInput": this.propSearchInput
          },
          "on": {
            "searchInputChange": val => this.propSearchInput = val
          },
          "style": {
            height: 'fit-content'
          }
        }));
      case 'yaml':
      case 'json':
      default:
        return h(CodeEditor, {
          "attrs": {
            "value": displayData,
            "defaultValue": {
              props: this.defaultProps,
              events: {}
            },
            "showDefaultProps": this.bus.options.showDefaultProps,
            "editOption": this.editOption,
            "maxHeight": this.maxHeight,
            "isDesignMode": this.isDesignMode,
            "isDarkMode": this.bus.options.darkMode
          },
          "on": {
            "change": this.handleDisplayDataChange,
            "update": val => {
              this.$set(this.bus.options, 'showDefaultProps', val);
            }
          }
        });
    }
  }
  headerLine(info) {
    const h = this.$createElement;
    return h("div", {
      "class": "ucd-devTool-layout-propPanel-json flex"
    }, [h("div", {
      "style": {
        display: 'flex'
      }
    }, [h("div", {
      "class": "header"
    }, [h("span", {
      "style": {
        marginRight: '-3px'
      }
    }, [" < "]), h("span", {
      "style": {
        color: 'green'
      }
    }, [" ", info.type, " "]), h("span", {
      "style": {
        marginLeft: '-3px'
      }
    }, [" > "])])]), h("a-button-group", [h("a-button", {
      "on": {
        "click": () => this.editOption = 'tree'
      },
      "attrs": {
        "type": this.editOption === 'tree' ? 'primary' : 'default',
        "size": "small"
      }
    }, ["Tree"]), h("a-button", {
      "on": {
        "click": () => this.editOption = 'yaml'
      },
      "attrs": {
        "type": this.editOption === 'yaml' ? 'primary' : 'default',
        "size": "small"
      }
    }, ["YAML"]), h("a-button", {
      "on": {
        "click": () => this.editOption = 'json'
      },
      "attrs": {
        "type": this.editOption === 'json' ? 'primary' : 'default',
        "size": "small"
      }
    }, ["JSON"])])]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-devTool-layout-item"
    }, [!this.activeLayout ? h("div", {
      "style": {
        textAlign: 'center'
      }
    }, [" \u9009\u62E9\u4E00\u4E2A\u7EC4\u4EF6\u4EE5\u67E5\u770B\u914D\u7F6E"]) : this.editContainer]);
  }
};
PropEditor = __decorate([Component({
  name: 'PropEditor'
})], PropEditor);
export default PropEditor;